var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"app-toolbar"},[_c('div',{staticClass:"app-toolbar__left"},[_vm._t("left")],2),_c('div',{staticClass:"app-toolbar__right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }